import Tone from 'tone';
import EQ8 from 'effects/EQ8.js';
import ConvolverReverbEffect from 'effects/ConvolverReverbEffect.js';
import DelayEffect from 'effects/Delay.js';
import UltraPhaser from 'effects/UltraPhaser.js';
import {REVERB, DELAY, PHASER} from 'constants/mixer-effects.js';
import {LOW, MID, HIGH} from 'constants/eq-types.js';

const ON_DB = 0;
const OFF_DB = -24;

class ChannelStripEffects {
    constructor(output, sequencerEngine) {
        this.output = output;
        this.sequencerEngine = sequencerEngine;

        // controls the effects level
        this.input = new Tone.Gain(1);

        // controls what frequencies get effected 
        this.eq = new EQ8(sequencerEngine, false);
        this.getLowEQ().frequencyParameter.set(250);
        this.getMidEQ().frequencyParameter.set(1000);
        this.getMidEQ().qParameter.set(0.9);
        this.getHighEQ().frequencyParameter.set(3400);

        this.convolverReverb = new ConvolverReverbEffect(sequencerEngine);
        this.convolverReverb.wet = 1;
        this.delay = new DelayEffect(sequencerEngine);
        this.delay.wet = 0;
        this.phaser = new UltraPhaser(sequencerEngine);
        this.phaser.rateParameter.set(0.2);
        this.phaser.feedbackParameter.set(0.4);
        this.phaser.wet = 0;

        this.input.connect(this.eq.effectNode);
        this.eq.connect(this.convolverReverb.effectNode);
        this.convolverReverb.connect(this.delay.effectNode);
        this.delay.connect(this.phaser.effectNode);

        this.phaser.connect(this.output);
    }

    getEQ(type) {
        switch (type) {
        case LOW:
            return this.getLowEQ();
        case MID:
            return this.getMidEQ();
        case HIGH:
            return this.getHighEQ();
        }

        return undefined;
    }

    toggleEQ(type) {
        let eq = this.getEQ(type);

        if (eq.gainParameter.get() === OFF_DB) {
            eq.gainParameter.set(ON_DB);
        } else {
            eq.gainParameter.set(OFF_DB);
        }
    }

    toggleEffect(effect) {
        switch (effect) {
        case REVERB:
            this.toggleReverb();
            break;
        case DELAY:
            this.toggleDelay();
            break;
        case PHASER:
            this.togglePhaser();
            break;
        }
    }

    toggleDelay() {
        if (this.delay.wetParameter.get() === 1) {
            this.delay.wet = 0;
        } else {
            this.delay.wet = 1;
        }
    }

    toggleReverb() {
        if (this.convolverReverb.wetParameter.get() === 1) {
            this.convolverReverb.wet = 0;
        } else {
            this.convolverReverb.wet = 1;
        }
    }

    togglePhaser() {
        if (this.phaser.wetParameter.get() === 1) {
            this.phaser.wet = 0;
        } else {
            this.phaser.wet = 1;
        }
    }

    set color(x) {
        this.delay.feedbackParameter.set(x*0.75);
        this.phaser.depthParameter.set(x);
        // this.phaser.feedbackParameter.set(x);
    }

    getLowEQ() {
        return this.eq.equalizerPoints[0];
    }

    getMidEQ() {
        return this.eq.equalizerPoints[4];
    }

    getHighEQ() {
        return this.eq.equalizerPoints[7];
    }
}

export default ChannelStripEffects;
